import { render, staticRenderFns } from "./ContactMoneyOrdersModal.vue?vue&type=template&id=259986e4&scoped=true"
import script from "./ContactMoneyOrdersModal.vue?vue&type=script&lang=js"
export * from "./ContactMoneyOrdersModal.vue?vue&type=script&lang=js"
import style0 from "./ContactMoneyOrdersModal.vue?vue&type=style&index=0&id=259986e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259986e4",
  null
  
)

export default component.exports